import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function FilterBar({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "v2-panel flex flex-wrap items-center gap-3 p-3",
        className
      )}
    >
      {children}
    </div>
  );
}
